import ReactDOM from "react-dom";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDiskSpaceModalStore } from "store/diskSpace.store";
import ModalsManagerContext from "contexts/ModalsManager";
import styles from "./styles.module.scss";

// Globalny modal o braku przestrzeni dyskowej — montowany raz w App.tsx, sterowany store'em.
// Wygląd wg projektu Figma (Basic dialog / error).
const DiskSpaceModal = () => {
  const { t } = useTranslation();
  const isOpen = useDiskSpaceModalStore((s) => s.isOpen);
  const close = useDiskSpaceModalStore((s) => s.close);
  const { modals, setModals } = useContext(ModalsManagerContext);

  if (!isOpen) {
    return null;
  }

  const increaseSpace = () => {
    close();
    setModals({ ...modals, settings: true, hide: false });
  };

  return ReactDOM.createPortal(
    <div className={styles.modal} onClick={close}>
      <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.title}>{t("diskSpaceModal.title")}</div>
          <div className={styles.body}>{t("diskSpaceModal.body")}</div>
        </div>

        <div className={styles.actions}>
          <button className={styles.secondaryBtn} onClick={close}>
            {t("diskSpaceModal.cancel")}
          </button>
          <button className={styles.primaryBtn} onClick={increaseSpace}>
            {t("diskSpaceModal.increaseSpace")}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DiskSpaceModal;
